import React, { useEffect, useState } from 'react';
import { ReactComponent as ThumbsUpIcon } from '../../../../components/icons/thumbs-up.svg';
import { EndOfTaggingFlowCardWrapper, Title, TitleAndSubtitleWrapper } from './EndOfTaggingFlowCardStyles';

interface IProps {
  isTagSaved: boolean;
}

export const EndOfTaggingFlowCard: React.FC<IProps> = (props) => {
  const { isTagSaved } = props;
  const [title, setTitle] = useState<string>('End of tagging flow');
  const [showSubtitle, setShowSubtitle] = useState<boolean>(false);

  useEffect(() => {
    if (isTagSaved) {
      setTitle('Tag saved');
      setShowSubtitle(false);
    } else {
      setTitle('End of tagging flow');
      setShowSubtitle(true);
    }
  }, [isTagSaved]);

  return (
    <EndOfTaggingFlowCardWrapper>
      <div>
        <ThumbsUpIcon />
      </div>
      <TitleAndSubtitleWrapper>
        <Title>{title}</Title>
        {showSubtitle && <div>Please press enter to save</div>}
      </TitleAndSubtitleWrapper>
    </EndOfTaggingFlowCardWrapper>
  );
};
